<template>
  <div class="view crm quick-add">
    <div class="page">
      <div class="header">
        <h3 class="text-black mt-2 mb-3">
          <strong>{{ $t('crm.quick-add.title') }}</strong>
        </h3>
      </div>
      <div class="card">
        <div class="top searchbox">
          <input
            type="text"
            v-model="search"
            @input="onInput"
            id="search"
            class="searchbar"
            name="search"
            :placeholder="$t('crm.quick-add.search')"
          />
          <small class="form-text text-warning" v-if="error">{{ error }}</small>
        </div>
        <div class="bottom loading" v-if="loading">
          <list-skeleton :list="7" />
        </div>
        <div class="bottom stages" v-if="!loading">
          <div class="stage stage-idle" v-if="!search">
            <a-empty />
            <div class="notification mt-3">
              <a-icon type="search" />
              <span class="font-size-18">{{ $t('crm.quick-add.type-to-search') }}</span>
            </div>
          </div>
          <div class="stage stage-searched animated fadeIn fast" v-if="customers">
            <CustomerListTable :customers="customers" />
          </div>
          <div class="stage stage-null animated fadeIn fast" v-if="search && !customers">
            <a-empty />
            <div class="notification mt-3 d-flex flex-column">
              <a-icon type="warn" />
              <span class="text-warning font-size-18 mb-3">
                {{ $t('crm.we-dont-find-any-information-about-this-customer') }}</span
              >
              <a-button @click="onNewCustomer" type="primary" icon="plus" size="large">Create New Customer</a-button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { CustomerListTable } from '@/components/reno/tables'
import { ListSkeleton } from '@/components/reno/skeleton'
import { searchCustomers } from '@/services/crm/customers'

export default {
  components: { ListSkeleton, CustomerListTable },
  data() {
    return {
      stopWatch: null,
      customers: null,
      error: null,
      search: null,
      loading: false,
    }
  },
  methods: {
    onInput() {
      this.loading = true
    },
    srartWatch() {
      this.stopWatch = this.$watch(
        'search',
        this.debounce((value) => {
          if (this.search) {
            this.onSearch(this.search)
          } else {
            this.customers = null
            this.loading = false
            this.error = null
          }
        }, 400),
      )
    },
    async onSearch(value) {
      try {
        this.loading = true
        this.customers = await searchCustomers(value)
        this.loading = false
      } catch (error) {
        console.error(error)
        this.loading = false
      }
    },
    onNewCustomer() {
      this.$store.dispatch('crm/open', 'CREATE_CUSTOMER')
    },
  },

  created() {
    this.srartWatch()
  },
  mounted() {
    document.getElementById('search').focus()
  },
  beforeDestroy() {
    this.stopWatch()
  },
}
</script>

<style lang="scss" scoped>
.crm.quick-add {
  .page {
    .card {
      min-height: 660px;
      display: flex;
      flex-direction: column;
      justify-content: flex-start;

      .searchbox {
        background: #f0f2f4;
        display: flex;
        width: 100%;

        .searchbar {
          flex: 1;
          border-radius: 5px;
          margin: 1rem;
          padding: 0.5rem 1rem;
          font-size: 1.8rem;
          border: 1px solid #fff;
          outline: unset;

          &:hover {
            border: 1px solid #0080ff;
          }
        }
      }

      .loading {
        flex: 1;
        width: 100;
      }

      .stages {
        flex: 1;
        display: flex;
        flex-direction: column;
        justify-content: center;

        .stage {
          flex: 1;
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
        }
        .stage-idle {
        }
        .stage-searched {
          align-items: unset;
          justify-content: flex-start;
        }
        .state-null {
          align-items: center;
        }
      }
    }
  }
}
</style>
